/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_b0594ee2"]'><div><cube-button @tap='(e)=>__invoke(e, [["showActionSheet"]])'>action-sheet-picker</cube-button><cube-action-sheet ref="__mpx_ref_actionSheet__" title="我是标题~~~" :inputData="(inputData)" :pickerStyle="(true)" @select='(e)=>__invoke(e, [["onSelect"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])' @maskClose='(e)=>__invoke(e, [["onMaskClose"]])'/><cube-toast :txt="(selectContent)" ref="__mpx_ref_selectToast__"></cube-toast></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_b0594ee2"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_b0594ee2"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_b0594ee2"}
  /** script content **/
  require("./action-sheet-picker.mpx.js?isComponent&outputPath=components%2Faction-sheet-pickerb0594ee2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./action-sheet-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Faction-sheet-pickerb0594ee2%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_b0594ee2"],
    ctorType: "component",
    outputPath: "components/action-sheet-pickerb0594ee2/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-action-sheet':getComponent(require("../../../packages/mpx-cube-ui/src/components/action-sheet/index.mpx?isComponent&outputPath=components%2Findex51c8754f%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>